import { ApiUser, ApiUserOrgRole } from '@kaiizen/kai-pro-api';

export const presentUser = (user: ApiUser) => user.name || user.phoneNumber || user.email || `User ${user.id}`;

const USER_ORG_ROLE_LABELS: Record<ApiUserOrgRole, string> = {
  fieldUser: 'Field User',
  manager: 'Manager',
  admin: 'Admin',
  opsUser: 'Ops User',
  viewer: 'Viewer',
};

export const presentUserOrgRole = (role: ApiUserOrgRole | string): string => USER_ORG_ROLE_LABELS[role as ApiUserOrgRole] ?? role;
